import './Schedule.css';

export const Schedule = () => (
  <div className='info--schedule-container'>
    <ul className='info--schedule-list'>

      <li className='info--schedule-element'>
        <span className='info--schedule-time'>
          15:00
        </span>
        <p className='info--schedule-event'>
          Заселение в отель.
        </p>
      </li>
      <li className='info--schedule-element'>
        <span className='info--schedule-time'>
          16:00
        </span>
        <p className='info--schedule-event'>
          Сбор гостей.
        </p>
      </li>
      <li className='info--schedule-element'>
        <span className='info--schedule-time'>
          17:00
        </span>
        <p className='info--schedule-event'>
          Начало церемонии.
        </p>
      </li>
      <li className='info--schedule-element'>
        <span className='info--schedule-time'>
          19:00
        </span>
        <p className='info--schedule-event'>
          Ужин.
        </p>
      </li>
    </ul>
  </div>
)
